import type { ValueEvent } from '@adornis/base/utilTypes.js';
import '@adornis/buchungsheld-components/authentication/bh-login.js';
import type { BHLogin } from '@adornis/buchungsheld-components/authentication/bh-login.js';
import { config } from '@adornis/buchungsheld-db/config.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-overlay.js';
import '@adornis/forms/x-checkbox.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { createRef, ref, type Ref } from 'lit/directives/ref.js';
import { BHRegistrationFlowSubPage } from './bh-page-registration-sub-page.js';

@customElement('bh-page-registration-auth')
export class BHPageRegistrationAuth extends BHRegistrationFlowSubPage {
  @state() private _mode?: 'Login_only_with_mail' | 'login_with_ldap' | 'token_validation';

  override backAction = () => {
    if (this._mode && this._hasExtraLoginMethods) {
      this.loginElement.value?.clear();
      this._mode = undefined;
    } else this._registrationController.previous();
  };
  override nextAction = null;

  private loginElement: Ref<BHLogin> = createRef();

  private get _hasExtraLoginMethods() {
    return config.get('LDAP_IMPLEMENTATION') || config.get('SAML_IMPLEMENTATION');
  }

  override content() {
    if (this._registrationController.stepInfo?.userIsLoggedIn) {
      console.warn('user should not see this screen');
      this.nextAction = () => this._registrationController.next(); // fallback
      return html`<x-loading-state></x-loading-state>`;
    }

    return html`
      <bh-login
        hide-back-button
        ${ref(this.loginElement)}
        @login=${() => this.proceed()}
        @mode-changed=${(e: ValueEvent<string | undefined>) =>
          this._mode !== e.detail.value && (this._mode = e.detail.value)}
        .mode=${this._mode}
      ></bh-login>
    `;
  }

  private async proceed() {
    this._registrationController.next();
  }
}
